import Vue from 'vue';
import Vuex from 'vuex';

import configModule from './config.module';
import posModule from './pos.module';
import geoModule from './geo.module';
import loadingModule from './loading.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config: configModule,
    pos: posModule,
    geo: geoModule,
    loading: loadingModule,
  },
});
